import { createSelector } from 'reselect';

import { getModeByModules, getModulesByExtensions, getModulesByMode } from 'constants/ModuleConstants';

import { filterRequestFormatter } from 'modules/interventions/utils';

import { getSelectedDealer, getSelectedDealerId } from 'selectors/dealerSelectors';

import { getCampaignById, getCampaignsByIds, getProps, getRoot, getUIState } from './index';

const getDashboardState = createSelector(getUIState, ui => ui.dashboard);

const getDataDashboard = createSelector(getDashboardState, state => state.data);

const getCampaignIds = createSelector(getDataDashboard, state => state.ids);

export const getCampaigns = createSelector(getRoot, getCampaignIds, getCampaignsByIds);

export const getPage = createSelector(getDataDashboard, state => state.page);

export const loading = createSelector(getDataDashboard, state => state.loading);

export const patching = createSelector(getDashboardState, getProps, (state, campaignId) =>
  state.loading.patch.includes(campaignId));

export const deleting = createSelector(getDashboardState, getProps, (state, campaignId) =>
  state.loading.delete.includes(campaignId));

export const getFilters = createSelector(getDashboardState, state => state.filters);

export const getBaseRequestParams = createSelector(
  getPage,
  getSelectedDealerId,
  getFilters,
  ({ size, number }, dealerId, filters) => ({
    size,
    dealerId,
    page: number,
    projection: 'page',
    ...filterRequestFormatter(filters),
  })
);

const getModalCreationState = createSelector(getUIState, state => state.creationModal);

export const isModalCreationOpen = createSelector(getModalCreationState, state => state.open);

export const isCreating = createSelector(getModalCreationState, state => state.creating);

const getModalDuplicateState = createSelector(getUIState, state => state.duplicateModal);

export const isModalDuplicateOpen = createSelector(getModalDuplicateState, state => state.open);

export const isCloning = createSelector(getModalDuplicateState, state => state.creating);

export const getDuplicatingCampaignId = createSelector(getDashboardState, state => state.campaignId);

export const createDefaultValue = createSelector(getSelectedDealer, dealer => {
  const mode = getModeByModules(getModulesByExtensions(dealer?.extensions)).at(0);
  const module = getModulesByMode(mode).at(0);

  return {
    mode,
    module,
    dealerId: dealer.id,
    brandId: dealer.brandIds?.at(1),
    language: dealer?.config?.general?.customerDefaultLanguage,
  };
});

export const getDuplicateDefaultValue = createSelector(getCampaignById, campaign => ({
  name: campaign.name,
  brandId: campaign.brandId,
  language: campaign.language,
}));
